import { escape as escapeHtml, escapeRegExp } from "lodash-es";

/** One occurrence of the search query inside one text item of one page. */
export interface PdfSearchMatch {
  pageIndex: number;
  itemIndex: number;
  start: number;
  end: number;
}

/** Literal, case-insensitive; a match never spans two text items. Matches against the original text to preserve offsets. */
export function findMatches(
  pages: readonly (readonly string[])[],
  query: string
): PdfSearchMatch[] {
  const needle = query.trim();
  if (needle === "") return [];
  const pattern = new RegExp(escapeRegExp(needle), "giu");
  const matches: PdfSearchMatch[] = [];
  pages.forEach((items, pageIndex) => {
    items.forEach((str, itemIndex) => {
      let match: RegExpExecArray | null;
      while ((match = pattern.exec(str)) !== null) {
        matches.push({
          pageIndex,
          itemIndex,
          start: match.index,
          end: match.index + match[0].length,
        });
      }
    });
  });
  return matches;
}

/** HTML for one text item — react-pdf injects it, so the PDF's text is escaped. */
export function highlightText(
  str: string,
  matches: readonly PdfSearchMatch[],
  active: PdfSearchMatch | null
): string {
  let html = "";
  let cursor = 0;
  for (const match of matches) {
    const isActive =
      active != null &&
      active.pageIndex === match.pageIndex &&
      active.itemIndex === match.itemIndex &&
      active.start === match.start;
    html += escapeHtml(str.slice(cursor, match.start));
    html += `<mark class="pdf-search-match"${isActive ? ' data-active="true"' : ""}>${escapeHtml(
      str.slice(match.start, match.end)
    )}</mark>`;
    cursor = match.end;
  }
  return html + escapeHtml(str.slice(cursor));
}
